// Valida que la cadena sea una MAC válida en formato AA:BB:CC:DD:EE:FF
export function isValidMac(mac) {
    const regex = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/;
    return regex.test(mac);
}